var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useContext } from 'react';
import { Toolbar, Typography, Box, List, ListItem, Drawer, Button, IconButton, Divider, } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Internal dependencies
import { CLIENT_ENDPOINTS, } from '../constants';
import { UserContext } from '../auth';
import { InfobaseIconSG, BrandVoiceIconSG, ChatIconSG, ProjectIconSG, UsageIconSG, } from '../components';
import { sideBarStyles } from './sideBarStyles';
import { TAB_IDS } from './constants';
import { AvatarSG, UpgradePlanSG } from '../components';
import { TabNamesTypes } from '../settings';
;
/**
 * Side Bar
 * @param {SideBarProps} props
 */
export const SideBar = function (props) {
    const { t, i18n } = useTranslation();
    const { tabId } = useParams();
    const { window, mobileOpen, handleDrawerToggle, drawerWidth, } = props;
    const navigate = useNavigate();
    const handleButtonClick = (url) => {
        navigate(url);
    };
    // Authorized user context
    const user = useContext(UserContext);
    /** Drawer main components */
    const drawer = (handleDrawerToggle) => (_jsxs(Box, Object.assign({ sx: {
            overflow: 'auto',
            backgroundColor: 'transparent',
            border: 'none'
        } }, { children: [_jsx(Toolbar, {}), _jsxs(List, Object.assign({ sx: {
                    padding: '1rem 0',
                } }, { children: [_jsx(ListItem, Object.assign({ sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            paddingBottom: '1rem',
                        }, disablePadding: true }, { children: _jsx(Button, Object.assign({ "aria-label": "Create chat shortcut", variant: "contained", color: "thirdary", sx: {
                                textAlign: 'center',
                                padding: '1rem',
                                borderRadius: '1rem',
                                boxSizing: 'border-box',
                                boxShadow: 'none',
                                minWidth: '0',
                            }, onClick: () => __awaiter(this, void 0, void 0, function* () {
                                navigate(CLIENT_ENDPOINTS.CHAT);
                            }) }, { children: _jsx(Add, { sx: { color: 'blackDark.main', width: '1.5rem', height: '1.5rem' } }) })) }), 'Create chat shortcut'), _jsxs(ListItem
                    // Chat button block
                    , Object.assign({ 
                        // Chat button block
                        sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            paddingBottom: '1rem',
                        }, disablePadding: true }, { children: [_jsx(IconButton
                            // Chat button
                            , Object.assign({ "aria-label": "Tab button", sx: sideBarStyles.sideBarItem(tabId, TAB_IDS.CHAT), onClick: () => __awaiter(this, void 0, void 0, function* () {
                                    navigate(CLIENT_ENDPOINTS.CHAT);
                                    return;
                                }) }, { children: _jsx(ChatIconSG, { styles: { color: 'blackDark.main', width: '1.5rem', height: '1.5rem' } }) })), _jsx(Typography, Object.assign({ variant: 'text12', sx: sideBarStyles.sideBarItemName }, { children: t('Chat') }))] }), 'Chat'), _jsxs(ListItem
                    // Project button block
                    , Object.assign({ 
                        // Project button block
                        sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            paddingBottom: '1rem',
                        }, disablePadding: true }, { children: [_jsx(IconButton, Object.assign({ "aria-label": "Project button", sx: sideBarStyles.sideBarItem(tabId, TAB_IDS.PROJECT), onClick: () => {
                                    handleButtonClick(CLIENT_ENDPOINTS.PROJECT);
                                    if (handleDrawerToggle) {
                                        handleDrawerToggle();
                                    }
                                    ;
                                } }, { children: _jsx(ProjectIconSG, { styles: { color: 'blackDark.main', width: '1.5rem', height: '1.5rem' } }) })), _jsx(Typography, Object.assign({ variant: 'text12', sx: sideBarStyles.sideBarItemName }, { children: t('Project') }))] }), 'Document'), _jsxs(ListItem, Object.assign({ sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            paddingBottom: '1rem',
                        }, disablePadding: true }, { children: [_jsx(IconButton, Object.assign({ "aria-label": "Brand voice button", sx: sideBarStyles.sideBarItem(tabId, TAB_IDS.BRAND_VOICE), onClick: () => {
                                    handleButtonClick(CLIENT_ENDPOINTS.BRAND_VOICE);
                                    if (handleDrawerToggle) {
                                        handleDrawerToggle();
                                    }
                                    ;
                                } }, { children: _jsx(BrandVoiceIconSG, { styles: { color: 'blackDark.main', width: '1.5rem', height: '1.5rem' } }) })), _jsx(Typography, Object.assign({ variant: 'text12', sx: sideBarStyles.sideBarItemName }, { children: t('Brand Voice') }))] }), 'Brand Voice'), _jsxs(ListItem, Object.assign({ sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            paddingBottom: '1rem',
                        }, disablePadding: true }, { children: [_jsx(IconButton, Object.assign({ "aria-label": "Infobase button", sx: sideBarStyles.sideBarItem(tabId, TAB_IDS.INFOBASE), onClick: () => {
                                    handleButtonClick(CLIENT_ENDPOINTS.INFOBASE);
                                    if (handleDrawerToggle) {
                                        handleDrawerToggle();
                                    }
                                    ;
                                } }, { children: _jsx(InfobaseIconSG, { styles: { color: 'blackDark.main', width: '1.5rem', height: '1.5rem' } }) })), _jsx(Typography, Object.assign({ variant: 'text12', sx: sideBarStyles.sideBarItemName }, { children: t('Infobase') }))] }), 'Infobase'), _jsx(Divider, {}), _jsxs(ListItem, Object.assign({ sx: {
                            flexDirection: 'column',
                            padding: '1rem 0',
                        }, disablePadding: true }, { children: [_jsx(UpgradePlanSG, { handleDrawerToggle: handleDrawerToggle }), _jsx(Typography, Object.assign({ variant: 'text12', sx: sideBarStyles.sideBarItemName }, { children: t('UPGRADE') }))] }), 'Upgrade'), _jsxs(ListItem, Object.assign({ sx: {
                            flexDirection: 'column',
                            paddingBottom: '1rem 0',
                        }, disablePadding: true }, { children: [_jsx(IconButton
                            // Upgrade button for mobile
                            , Object.assign({ "aria-label": "Usage Button", onClick: () => {
                                    navigate(CLIENT_ENDPOINTS.SETTINGS + '/?tab=' + TabNamesTypes.Billing);
                                    if (handleDrawerToggle) {
                                        // If it's in the side bar
                                        handleDrawerToggle();
                                    }
                                    return;
                                } }, { children: _jsx(UsageIconSG, { sx: { color: 'blackDark.main' } }) })), _jsx(Typography, Object.assign({ variant: 'text12', sx: sideBarStyles.sideBarItemName }, { children: t('Usage') }))] }), 'Usage'), _jsxs(ListItem, Object.assign({ sx: {
                            display: {
                                xs: user ? 'flex' : 'none',
                                md: 'none',
                            },
                            flexDirection: 'column',
                            padding: '0 0 1rem 0',
                        }, disablePadding: true }, { children: [_jsx(AvatarSG, { sx: { display: { xs: 'flex', md: 'none' } }, handleDrawerToggle: handleDrawerToggle }), _jsx(Typography, Object.assign({ variant: 'text12', sx: sideBarStyles.sideBarItemName }, { children: t('Account') }))] }), 'AvatarSG')] }))] })));
    const container = window !== undefined ? () => window().document.body : undefined;
    return (_jsxs(Box, Object.assign({ component: "nav", sx: { width: { md: drawerWidth } }, "aria-label": "mailbox folders" }, { children: [_jsx(Drawer
            // Mobile drawer
            , Object.assign({ 
                // Mobile drawer
                container: container, variant: "temporary", open: mobileOpen, onClose: handleDrawerToggle, ModalProps: {
                    keepMounted: true,
                }, sx: {
                    display: { xs: 'block', md: 'none' },
                    '& .MuiDrawer-paper': {
                        backgroundColor: 'whiteDark.main',
                        boxSizing: 'border-box',
                        width: drawerWidth,
                        border: 'none',
                        borderRadius: '0!important',
                    },
                } }, { children: drawer(handleDrawerToggle) })), _jsx(Drawer
            // Desktop drawer
            , Object.assign({ 
                // Desktop drawer
                variant: "permanent", sx: {
                    flexShrink: 0,
                    display: { xs: 'none', md: 'block' },
                    '& .MuiDrawer-paper': {
                        backgroundColor: 'whiteDark.main',
                        boxSizing: 'border-box',
                        width: drawerWidth,
                        border: 'none',
                        borderRadius: '0!important',
                    },
                }, open: true }, { children: drawer(null) }))] })));
};
